<template>
  <v-flex xs12>
    <v-card @click="goToShowProduct(product.id)" class="pointer">
      <v-layout>
        <v-flex ma-3 xs5>
          <img :src="product.main_image" style="height: 200px; width: 200px; object-fit: cover;" />
        </v-flex>
        <v-layout row wrap>
          <v-flex xs12 pt-4>
              <div>
                <div class="grey-security">
                  Subido: {{product.published_date}}
                </div>
                <div 
                  class="text-27-security font-weight-bold blue-security pt-2"
                >
                  {{product.name}}
                </div>
              </div>
          </v-flex>
          <v-layout align-end>
            <v-flex xs12 pt-4 pb-4>
              <div 
                v-if="product.approved" 
                class="green-security text-14-security"
                style="bottom: 0;"
              >
                <i class="fas fa-check"></i> Aprobado
              </div>
              <div v-else class="red-security text-14-security">
                <i class="fas fa-times"></i> Rechazado
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations("products", ["setProduct"]),
    goToShowProduct(id) {
      this.$router.push({
        name: "product-show",
        params: { id: id, myProduct: true }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

